import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { CompanyListsActionsComponent }           from './company-lists.actions.component';
import { CompanyListsComponent }                  from './company-lists.component';
import { CompanyListsCustomerSourcesComponent }   from './company-lists.customer-sources.component';
import { CompanyListsPaymentMethodsComponent }    from './company-lists.payment-methods.component';
import { CompanyListsProductCategoriesComponent } from './company-lists.product-categories.component';
import { CompanyListsProductGroupsComponent }     from './company-lists.product-groups.component';
import { CompanyListsTemplateComponent }          from './company-lists.template.component';
import { CompanyListsTemplatesComponent }         from './company-lists.templates.component';
import { CompanyListsService }                    from './company-lists.service';
import { CompanyListsStates }                     from './company-lists.states';
import { SharedModule }                           from '../shared/shared.module';
import { TableModule }                            from '../table/table.module';

@NgModule({
  declarations: [
    CompanyListsActionsComponent,
    CompanyListsComponent,
    CompanyListsCustomerSourcesComponent,
    CompanyListsPaymentMethodsComponent,
    CompanyListsProductCategoriesComponent,
    CompanyListsProductGroupsComponent,
    CompanyListsTemplateComponent,
    CompanyListsTemplatesComponent
  ],
  entryComponents: [
    CompanyListsActionsComponent,
    CompanyListsComponent,
    CompanyListsCustomerSourcesComponent,
    CompanyListsPaymentMethodsComponent,
    CompanyListsProductCategoriesComponent,
    CompanyListsProductGroupsComponent,
    CompanyListsTemplateComponent,
    CompanyListsTemplatesComponent
  ],
  exports: [
    CompanyListsCustomerSourcesComponent,
    CompanyListsPaymentMethodsComponent,
    CompanyListsProductCategoriesComponent,
    CompanyListsProductGroupsComponent,
    CompanyListsTemplatesComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: CompanyListsStates })
  ],
  providers: [
    CompanyListsService
  ]
})
export class CompanyListsModule {}
